import React from "react";
import onClickOutside from "react-onclickoutside";
import { FormattedMessage } from "react-intl";

import { PictureAsPdf, Description } from "components/Icons";

import "./style.scss";

interface IProps {
  id?: string;
  visible: boolean;
  clickedOutside: () => void;
  downloadFile: (string) => void;
}

class ExportReport extends React.Component<IProps> {
  public handleClickOutside() {
    this.props.clickedOutside();
  }

  public render() {
    const { id = "", visible, downloadFile } = this.props;

    return (
      visible && (
        <div className="export-report">
          <div id={`${id}-excel`} onClick={() => downloadFile("Excel")}>
            <Description />
            <FormattedMessage id="REPORTS_EXCEL" />
          </div>
          <div id={`${id}-pdf`} onClick={() => downloadFile("PDF")}>
            <PictureAsPdf />
            <FormattedMessage id="REPORTS_PDF" />
          </div>
        </div>
      )
    );
  }
}

export default onClickOutside(ExportReport);
